const debug = import.meta.env.MODE !== 'production';

export default debug;
